import * as types from './constants';

// Get Unmasking Connections
export const getUnmaskingConnectionsRequest = data => (
  { type: types.GET_UNMASKING_CONNECTIONS_REQUEST, payload: data }
);

export const getUnmaskingConnectionsDone = data => (
  { type: types.GET_UNMASKING_CONNECTIONS_DONE, payload: data }
);

export const getUnmaskingConnectionsFailed = errors => (
  { type: types.GET_UNMASKING_CONNECTIONS_FAILED, payload: errors }
);

// Operations
export const unmaskingConnectionsSetPage = data => (
  { type: types.UNMASKING_CONNECTIONS_SET_PAGE, payload: data }
);

export const toggleUnmaskingConnections = data => (
  { type: types.TOGGLE_UNMASKING_CONNECTIONS, payload: data }
);

export const toggleAllUnmaskingConnections = data => (
  { type: types.TOGGLE_ALL_UNMASKING_CONNECTIONS, payload: data }
);